import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
function moviesItemSkeletion() {
    return (
        <SkeletonTheme color="#2020201c" highlightColor="#93939385">
            <div className="card movie_card mb-3">
                <img src={process.env.PUBLIC_URL + "/Thamnail.png"} alt="thumbnail" />
                <div className="card-body p-2">
                    <span target="_blank"> <Skeleton width={`50px`} height={`50px`} className="play_button" /></span>
                    <h6 className="card-title mt-2"><Skeleton width={150} /></h6>
                    <div className="clearfix">
                        <span className="movie_info "><Skeleton width={60} /></span>
                        <span className="movie_info float-end"><Skeleton width={60} /></span>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    )
}

export default moviesItemSkeletion